const REFRESH_INTERACTION = "refresh";
const TIME_RANGE_CHANGE_INTERACTION = "time_range_change";
const FILTER_REMOVED_INTERACTION = "filter_removed";
const FILTER_CHANGED_INTERACTION = "filter_changed";
const FILTER_RESTORED_INTERACTION = "filter_restored";
const VARIABLE_VALUE_CHANGED_INTERACTION = "variable_value_changed";
const SCOPES_CHANGED_INTERACTION = "scopes_changed";
const ADHOC_KEYS_DROPDOWN_INTERACTION = "adhoc_keys_dropdown";
const ADHOC_VALUES_DROPDOWN_INTERACTION = "adhoc_values_dropdown";
const GROUPBY_DIMENSIONS_INTERACTION = "groupby_dimensions";

export { ADHOC_KEYS_DROPDOWN_INTERACTION, ADHOC_VALUES_DROPDOWN_INTERACTION, FILTER_CHANGED_INTERACTION, FILTER_REMOVED_INTERACTION, FILTER_RESTORED_INTERACTION, GROUPBY_DIMENSIONS_INTERACTION, REFRESH_INTERACTION, SCOPES_CHANGED_INTERACTION, TIME_RANGE_CHANGE_INTERACTION, VARIABLE_VALUE_CHANGED_INTERACTION };
//# sourceMappingURL=interactionConstants.js.map
